import { QueryKey, useMutation, useQuery } from '@tanstack/react-query'
import { signupNewsletter } from './user.service'

const QUERY_KEY = 'user'

export function getUserKey(type: string): QueryKey {
  return [QUERY_KEY, type]
}

export function useNewsletter() {
  return useMutation({
    mutationKey: getUserKey('newsletter'),
    mutationFn: signupNewsletter,
  })
}
